import React, {useState} from "react";
export default (props) => {
	const [input1, onChangeInput1] = useState('');
	const [input2, onChangeInput2] = useState('');
	return (
		<div 
			style={{
				display: "flex",
				flexDirection: "column",
				background: "#FFFFFF",
			}}>
			<div 
				style={{
					height: 3179,
					alignSelf: "stretch",
					background: "#F6F7F9",
				}}>
				<div 
					style={{
						alignSelf: "stretch",
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-start",
						paddingBottom: 89,
					}}>
					<div 
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-start",
							position: "relative",
						}}>
						{/* <div 
							style={{
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 32,
								paddingBottom: 444,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/sbz5gky4_expires_30_days.png"} 
								style={{
									width: 80,
									height: 80,
									marginBottom: 16,
									marginLeft: 32,
									objectFit: "fill",
								}}
							/>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 14,
									marginLeft: 32,
									marginRight: 32,
									gap: 12,
								}}>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 18,
										fontWeight: "bold",
									}} >
									{"Guy Hawkins"}
								</span>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 3,
										paddingTop: 1,
										paddingBottom: 1,
										paddingLeft: 6,
										paddingRight: 6,
									}}>
									<span 
										style={{
											color: "#FFFFFF",
											fontSize: 10,
											fontWeight: "bold",
										}} >
										{"Mentee"}
									</span>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									paddingRight: 2,
									marginBottom: 64,
									marginLeft: 32,
									marginRight: 32,
									gap: 6,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/dut20ibb_expires_30_days.png"} 
									style={{
										width: 15,
										height: 15,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
									}} >
									{"yourguy123@email.com"}
								</span>
							</div>
							<span 
								style={{
									color: "#979797",
									fontSize: 12,
									fontWeight: "bold",
									marginBottom: 32,
									marginLeft: 32,
								}} >
								{"MAIN MENU"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/bbzxa360_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Dashboard"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 4,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/rurnfd51_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Requests"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/rhfelmd8_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"My Goals"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/axjpa6c7_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Chats"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 30,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/rk39wp4a_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Curriculum"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
									borderRadius: 8,
									paddingTop: 10,
									paddingBottom: 10,
									paddingLeft: 12,
									paddingRight: 12,
									marginBottom: 30,
									marginLeft: 20,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/gyt2ncl7_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<input
									placeholder={"Lessons"}
									value={input1}
									onChange={(event)=>onChangeInput1(event.target.value)}
									style={{
										color: "#FFFFFF",
										fontSize: 16,
										fontWeight: "bold",
										width: 61,
										background: "none",
										border: "none",
										paddingTop: 2,
										paddingBottom: 2,
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/yitvgsrs_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Resources"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/gzbtqm2j_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Mentors"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/l0wl0185_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Progress"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/2ft29jiv_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Community"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/1x8apv2m_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Bookmarks"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/b7tx1pve_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Downloads"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									marginRight: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/cjyke67l_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Notifications"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/v3gxg3s7_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Settings"}
								</span>
							</div>
						</div> */}
						<div 
							style={{
								position: "absolute",
								top: 211,
								left: 0,
								width: 236,
								height: 1,
								background: "#E6E6E6",
							}}>
						</div>
						<div 
							style={{
								position: "absolute",
								bottom: 0,
								left: 227,
								width: 1213,
								display: "flex",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 20,
								paddingBottom: 20,
								paddingLeft: 40,
								paddingRight: 40,
								boxShadow: "0px -2px 4px #00000000",
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									flex: 1,
								}} >
								{"© 2025 Global Impact Innovators. All Rights Reserved."}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 27,
								}} >
								{"Privacy"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 26,
								}} >
								{"Terms of Service"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
								}} >
								{"Help & FAQ"}
							</span>
						</div>
					</div>
					<div 
						style={{
							display: "flex",
							alignItems: "center",
							background: "#FFFFFF",
							paddingTop: 20,
							paddingBottom: 20,
							paddingLeft: 33,
							paddingRight: 33,
							marginBottom: 32,
							marginLeft: 234,
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#F6F7F9",
								borderRadius: 8,
								paddingTop: 14,
								paddingBottom: 14,
								paddingLeft: 20,
								paddingRight: 20,
								marginRight: 257,
								gap: 12,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/vb4s7mnp_expires_30_days.png"} 
								style={{
									width: 21,
									height: 21,
									objectFit: "fill",
								}}
							/>
							<input
								placeholder={"For quick access to courses, mentors, or posts"}
								value={input2}
								onChange={(event)=>onChangeInput2(event.target.value)}
								style={{
									color: "#6C6C6C",
									fontSize: 14,
									width: 306,
									background: "none",
									border: "none",
									paddingTop: 2,
									paddingBottom: 2,
								}}
							/>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#FEF0E9",
								borderRadius: 8,
								paddingTop: 10,
								paddingBottom: 10,
								paddingLeft: 20,
								paddingRight: 23,
								marginRight: 32,
								gap: 8,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/xom3x3a5_expires_30_days.png"} 
								style={{
									width: 32,
									height: 32,
									objectFit: "fill",
								}}
							/>
							<span 
								style={{
									color: "#F57E47",
									fontSize: 17,
									fontWeight: "bold",
								}} >
								{"Ask Giia"}
							</span>
						</div>
						<div 
							style={{
								width: 1,
								height: 58,
								background: "#E6E6E6",
								marginRight: 31,
							}}>
						</div>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ov971oaq_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								marginRight: 24,
								objectFit: "fill",
							}}
						/>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ewnkxdze_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								objectFit: "fill",
							}}
						/>
					</div>
					<span 
						style={{
							color: "#010101",
							fontSize: 40,
							fontWeight: "bold",
							marginLeft: 267,
						}} >
						{"Lessons"}
					</span>
					<div 
						style={{
							alignSelf: "stretch",
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-end",
							marginBottom: 41,
						}}>
						<span 
							style={{
								color: "#6C6C6C",
								fontSize: 18,
								marginRight: 36,
							}} >
							{"Explore all lessons."}
						</span>
					</div>
					<div 
						style={{
							display: "flex",
							alignItems: "flex-start",
							background: "#FFFFFF",
							borderRadius: 12,
							paddingLeft: 20,
							paddingRight: 20,
							marginLeft: 267,
							boxShadow: "0px 1px 3px #00000003",
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
								marginRight: 20,
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 15,
								}} >
								{"Course"}
							</span>
							<div 
								style={{
									width: 290,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 24,
								}}>
							</div>
							<span 
								style={{
									color: "#010101",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 24,
								}} >
								{"Entrepreneurship Fundamentals"}
							</span>
							<span 
								style={{
									color: "#2C2C2C",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 20,
								}} >
								{"Lessons (6)"}
							</span>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									marginBottom: 16,
									gap: 4,
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										marginLeft: 16,
										gap: 12,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/3d4um714_expires_30_days.png"} 
										style={{
											width: 61,
											height: 61,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 8,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 14,
												fontWeight: "bold",
												width: 161,
											}} >
											{"Financial Projections for Startups"}
										</span>
										<span 
											style={{
												color: "#979797",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Lesson Type: Text Lesson"}
										</span>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										paddingRight: 2,
										marginLeft: 89,
										gap: 4,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/i6k68mgb_expires_30_days.png"} 
										style={{
											width: 11,
											height: 11,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#0BBB0D",
											fontSize: 11,
											fontWeight: "bold",
										}} >
										{"Completed"}
									</span>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#E6F7FD4D",
									borderRadius: 12,
									border: `1px solid #00AEEF`,
									paddingTop: 16,
									paddingBottom: 16,
									marginBottom: 16,
									gap: 4,
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										marginLeft: 16,
										gap: 12,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/hip6n80l_expires_30_days.png"} 
										style={{
											width: 61,
											height: 61,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											gap: 8,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 14,
												fontWeight: "bold",
												width: 150,
											}} >
											{"Understanding Market Research"}
										</span>
										<span 
											style={{
												color: "#979797",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Lesson Type: Text Lesson"}
										</span>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										paddingRight: 3,
										marginLeft: 89,
										gap: 4,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jtbkqy3h_expires_30_days.png"} 
										style={{
											width: 11,
											height: 11,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#EEBD10",
											fontSize: 11,
											fontWeight: "bold",
										}} >
										{"In Progress"}
									</span>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									marginBottom: 16,
									gap: 4,
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										marginLeft: 16,
										gap: 12,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jifrl1gv_expires_30_days.png"} 
										style={{
											width: 61,
											height: 61,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 8,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 14,
												fontWeight: "bold",
												width: 121,
											}} >
											{"Business Planning Strategies"}
										</span>
										<span 
											style={{
												color: "#979797",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Lesson Type: Text Lesson"}
										</span>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										paddingRight: 3,
										marginLeft: 89,
										gap: 4,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/p8szqp78_expires_30_days.png"} 
										style={{
											width: 11,
											height: 11,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 11,
											fontWeight: "bold",
										}} >
										{"Not Started"}
									</span>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									marginBottom: 16,
									gap: 4,
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										marginLeft: 16,
										gap: 12,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/6q999ujt_expires_30_days.png"} 
										style={{
											width: 61,
											height: 61,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 8,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 14,
												fontWeight: "bold",
												width: 161,
											}} >
											{"Financial Projections for Startups"}
										</span>
										<span 
											style={{
												color: "#979797",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Lesson Type: Text Lesson"}
										</span>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										paddingRight: 3,
										marginLeft: 89,
										gap: 4,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/3zf7hzuf_expires_30_days.png"} 
										style={{
											width: 11,
											height: 11,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 11,
											fontWeight: "bold",
										}} >
										{"Not Started"}
									</span>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									marginBottom: 16,
									gap: 4,
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										marginLeft: 16,
										gap: 12,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/0zitsgcr_expires_30_days.png"} 
										style={{
											width: 61,
											height: 61,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 8,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 14,
												fontWeight: "bold",
												width: 161,
											}} >
											{"Financial Projections for Startups"}
										</span>
										<span 
											style={{
												color: "#979797",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Lesson Type: Text Lesson"}
										</span>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										paddingRight: 3,
										marginLeft: 89,
										gap: 4,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/dvnoi1fc_expires_30_days.png"} 
										style={{
											width: 11,
											height: 11,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 11,
											fontWeight: "bold",
										}} >
										{"Not Started"}
									</span>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									gap: 4,
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										marginLeft: 16,
										gap: 12,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/90cl8yp8_expires_30_days.png"} 
										style={{
											width: 61,
											height: 61,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 8,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 14,
												fontWeight: "bold",
												width: 161,
											}} >
											{"Financial Projections for Startups"}
										</span>
										<span 
											style={{
												color: "#979797",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Lesson Type: Text Lesson"}
										</span>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										paddingRight: 3,
										marginLeft: 89,
										gap: 4,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jaaat6hi_expires_30_days.png"} 
										style={{
											width: 11,
											height: 11,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 11,
											fontWeight: "bold",
										}} >
										{"Not Started"}
									</span>
								</div>
							</div>
						</div>
						<div 
							style={{
								width: 1,
								height: 1250,
								background: "#E6E6E6",
								marginRight: 23,
							}}>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
								marginRight: 24,
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 15,
								}} >
								{"Lesson Details"}
							</span>
							<div 
								style={{
									width: 475,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 24,
								}}>
							</div>
							<span 
								style={{
									color: "#010101",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 24,
								}} >
								{"Lesson Title & Summary"}
							</span>
							<span 
								style={{
									color: "#010101",
									fontSize: 20,
									fontWeight: "bold",
									marginBottom: 12,
								}} >
								{"Understanding Market Research"}
							</span>
							<span 
								style={{
									color: "#6C6C6C",
									fontSize: 14,
									marginBottom: 24,
									width: 442,
								}} >
								{"This lesson covers essential market research techniques to identify customer needs and analyze competition."}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 28,
									gap: 16,
								}}>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										alignItems: "center",
										background: "#FEF0E9",
										borderRadius: 8,
										paddingTop: 10,
										paddingBottom: 10,
										paddingLeft: 12,
										paddingRight: 12,
										gap: 8,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/e1lrbift_expires_30_days.png"} 
										style={{
											width: 25,
											height: 25,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											gap: 4,
										}}>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 10,
											}} >
											{"Completion Time"}
										</span>
										<span 
											style={{
												color: "#2C2C2C",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Approx. 15 min"}
										</span>
									</div>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										alignItems: "center",
										background: "#E6F7FD",
										borderRadius: 8,
										paddingTop: 10,
										paddingBottom: 10,
										paddingLeft: 12,
										paddingRight: 12,
										gap: 8,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/sknasuhy_expires_30_days.png"} 
										style={{
											width: 25,
											height: 25,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 4,
										}}>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 10,
											}} >
											{"Lesson Progress"}
										</span>
										<span 
											style={{
												color: "#6BD0F6",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Completed 25%"}
										</span>
									</div>
								</div>
							</div>
							<div 
								style={{
									width: 475,
									height: 6,
									background: "#F1F2F4",
									marginBottom: 28,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									paddingRight: 3,
									marginBottom: 24,
									gap: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/uljyoszf_expires_30_days.png"} 
									style={{
										width: 9,
										height: 22,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#010101",
										fontSize: 18,
										fontWeight: "bold",
									}} >
									{"Lesson Details"}
								</span>
							</div>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ppjy2ine_expires_30_days.png"} 
								style={{
									width: 475,
									height: 121,
									marginBottom: 28,
									objectFit: "fill",
								}}
							/>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 28,
								}}>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										marginRight: 181,
										gap: 12,
									}}>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
										}} >
										{"Lesson Type"}
									</span>
									<span 
										style={{
											color: "#2C2C2C",
											fontSize: 14,
											fontWeight: "bold",
										}} >
										{"Text Lesson"}
									</span>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 12,
									}}>
									<div 
										style={{
											alignSelf: "stretch",
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-end",
										}}>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 12,
												marginRight: 3,
											}} >
											{"Lesson"}
										</span>
									</div>
									<span 
										style={{
											color: "#2C2C2C",
											fontSize: 14,
											fontWeight: "bold",
										}} >
										{"Understanding Market Research"}
									</span>
								</div>
							</div>
							<span 
								style={{
									color: "#6C6C6C",
									fontSize: 12,
									marginBottom: 12,
								}} >
								{"Introduction"}
							</span>
							<span 
								style={{
									color: "#2C2C2C",
									fontSize: 14,
									fontWeight: "bold",
									marginBottom: 24,
									width: 396,
								}} >
								{"Market research is the process of gathering, analyzing, and interpreting data about a target market, product, or service."}
							</span>
							<span 
								style={{
									color: "#6C6C6C",
									fontSize: 12,
									marginBottom: 12,
								}} >
								{"Types of Market Research"}
							</span>
							<span 
								style={{
									color: "#1074BC",
									fontSize: 14,
									marginBottom: 16,
								}} >
								{"Primary Research: Conducting surveys, interviews, focus groups"}
							</span>
							<span 
								style={{
									color: "#1074BC",
									fontSize: 14,
									marginBottom: 28,
									width: 408,
								}} >
								{"Secondary Research: Using existing reports, industry trends, government publications"}
							</span>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									marginBottom: 28,
									gap: 12,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
									}} >
									{"Key Steps in Market Research:"}
								</span>
								<span 
									style={{
										color: "#010101",
										fontSize: 14,
										fontWeight: "bold",
										width: 307,
									}} >
									{"Define the Research Objective\nIdentify Target Audience\nCollect Data (Surveys, Questionnaires, etc.)\nAnalyze Data and Generate Insights"}
								</span>
							</div>
							<span 
								style={{
									color: "#6C6C6C",
									fontSize: 12,
									marginBottom: 12,
								}} >
								{"Example:"}
							</span>
							<span 
								style={{
									color: "#010101",
									fontSize: 14,
									fontWeight: "bold",
									marginBottom: 28,
									width: 446,
								}} >
								{"If you're launching a new fitness app, market research can help you understand what features users want most."}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									paddingRight: 3,
									marginBottom: 20,
									gap: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/pub4abq4_expires_30_days.png"} 
									style={{
										width: 9,
										height: 22,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#010101",
										fontSize: 18,
										fontWeight: "bold",
									}} >
									{"Key Takeaways"}
								</span>
							</div>
							<span 
								style={{
									color: "#1074BC",
									fontSize: 14,
									fontWeight: "bold",
									marginBottom: 20,
									width: 449,
								}} >
								{"Market research helps identify customer pain points and demand gaps."}
							</span>
							<span 
								style={{
									color: "#1074BC",
									fontSize: 14,
									fontWeight: "bold",
									width: 409,
								}} >
								{"Competitive analysis is essential for positioning your brand effectively."}
							</span>
						</div>
						<div 
							style={{
								width: 1,
								height: 1250,
								background: "#E6E6E6",
								marginRight: 23,
							}}>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 15,
								}} >
								{"Notes & Tools"}
							</span>
							<div 
								style={{
									width: 244,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 24,
								}}>
							</div>
							<span 
								style={{
									color: "#010101",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 16,
								}} >
								{"Notes"}
							</span>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 8,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 68,
									paddingLeft: 20,
									paddingRight: 80,
									marginBottom: 12,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
									}} >
									{"Write here your notes."}
								</span>
							</div>
							<div 
								style={{
									alignSelf: "stretch",
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-end",
									marginBottom: 23,
								}}>
								<span 
									style={{
										color: "#74AED8",
										fontSize: 14,
										fontWeight: "bold",
										marginRight: 2,
									}} >
									{"+ Add note"}
								</span>
							</div>
							<div 
								style={{
									width: 244,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 24,
								}}>
							</div>
							<span 
								style={{
									color: "#010101",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 16,
								}} >
								{"Downloads"}
							</span>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									marginBottom: 16,
									gap: 16,
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										marginLeft: 16,
										gap: 12,
									}}>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											paddingTop: 23,
											paddingBottom: 4,
											gap: 8,
											backgroundImage: 'url(https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/3gmljpkt_expires_30_days.png)',
											backgroundSize: "cover",
											backgroundPosition: "center",
										}}>
										<div 
											style={{
												alignSelf: "stretch",
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/vvuxuv8x_expires_30_days.png"} 
												style={{
													width: 16,
													height: 16,
													objectFit: "fill",
												}}
											/>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												paddingRight: 2,
												marginLeft: 25,
												gap: 2,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/v6ho81ir_expires_30_days.png"} 
												style={{
													width: 8,
													height: 8,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#FFFFFF",
													fontSize: 8,
													fontWeight: "bold",
												}} >
												{"12:45"}
											</span>
										</div>
									</div>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 8,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 14,
												fontWeight: "bold",
												width: 112,
											}} >
											{"Market Research Strategies"}
										</span>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 10,
												fontWeight: "bold",
											}} >
											{"Video"}
										</span>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 6,
										border: `1px solid #00000000`,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 63,
										paddingRight: 64,
										marginLeft: 16,
										marginRight: 16,
										gap: 4,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/juixp6xa_expires_30_days.png"} 
										style={{
											width: 15,
											height: 15,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#6BD0F6",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Watch Now"}
									</span>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									marginBottom: 16,
									gap: 16,
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										marginLeft: 16,
										gap: 12,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/j6caf0p7_expires_30_days.png"} 
										style={{
											width: 61,
											height: 61,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 8,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 14,
												fontWeight: "bold",
												width: 92,
											}} >
											{"Business Plan Template"}
										</span>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 10,
												fontWeight: "bold",
											}} >
											{"Template"}
										</span>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 6,
										border: `1px solid #00000000`,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 67,
										paddingRight: 68,
										marginLeft: 16,
										marginRight: 16,
										gap: 4,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/8r14pc6o_expires_30_days.png"} 
										style={{
											width: 15,
											height: 15,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#6BD0F6",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"View Now"}
									</span>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									marginBottom: 23,
									gap: 16,
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										marginLeft: 16,
										gap: 12,
									}}>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											paddingTop: 23,
											paddingBottom: 4,
											gap: 8,
											backgroundImage: 'url(https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/zjapianf_expires_30_days.png)',
											backgroundSize: "cover",
											backgroundPosition: "center",
										}}>
										<div 
											style={{
												alignSelf: "stretch",
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/eovlijyx_expires_30_days.png"} 
												style={{
													width: 16,
													height: 16,
													objectFit: "fill",
												}}
											/>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												paddingRight: 2,
												marginLeft: 25,
												gap: 2,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/njwcut7s_expires_30_days.png"} 
												style={{
													width: 8,
													height: 8,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#FFFFFF",
													fontSize: 8,
													fontWeight: "bold",
												}} >
												{"12:45"}
											</span>
										</div>
									</div>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 8,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 14,
												fontWeight: "bold",
												width: 112,
											}} >
											{"Market Research Strategies"}
										</span>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 10,
												fontWeight: "bold",
											}} >
											{"Video"}
										</span>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 6,
										border: `1px solid #00000000`,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 63,
										paddingRight: 64,
										marginLeft: 16,
										marginRight: 16,
										gap: 4,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jvjywz1d_expires_30_days.png"} 
										style={{
											width: 15,
											height: 15,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#6BD0F6",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Watch Now"}
									</span>
								</div>
							</div>
							<div 
								style={{
									width: 244,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 24,
								}}>
							</div>
							<span 
								style={{
									color: "#010101",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 16,
								}} >
								{"Quick Links"}
							</span>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									marginBottom: 16,
								}}>
								<span 
									style={{
										color: "#F57E47",
										fontSize: 10,
										fontWeight: "bold",
										marginBottom: 12,
										marginLeft: 16,
									}} >
									{"Digital Marketing"}
								</span>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 16,
										fontWeight: "bold",
										marginBottom: 16,
										marginLeft: 16,
									}} >
									{"HubSpot Marketing Blog"}
								</span>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginLeft: 16,
										marginRight: 16,
										gap: 17,
									}}>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "flex-start",
											paddingRight: 2,
											gap: 4,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/j2sshha7_expires_30_days.png"} 
											style={{
												width: 15,
												height: 15,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#6BD0F6",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Visit website"}
										</span>
									</div>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "flex-start",
											paddingRight: 2,
											gap: 4,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/kja9xjna_expires_30_days.png"} 
											style={{
												width: 15,
												height: 15,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#979797",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Save for Later"}
										</span>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									marginBottom: 16,
								}}>
								<span 
									style={{
										color: "#F57E47",
										fontSize: 10,
										fontWeight: "bold",
										marginBottom: 12,
										marginLeft: 16,
									}} >
									{"Research & Analytics"}
								</span>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 16,
										fontWeight: "bold",
										marginBottom: 16,
										marginLeft: 16,
										width: 199,
									}} >
									{"Statista – Business Data & Market Research"}
								</span>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginLeft: 16,
										marginRight: 16,
										gap: 17,
									}}>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "flex-start",
											paddingRight: 2,
											gap: 4,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/82b4cbof_expires_30_days.png"} 
											style={{
												width: 15,
												height: 15,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#6BD0F6",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Visit website"}
										</span>
									</div>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "flex-start",
											paddingRight: 2,
											gap: 4,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/2ehs06bc_expires_30_days.png"} 
											style={{
												width: 15,
												height: 15,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#979797",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Save for Later"}
										</span>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
								}}>
								<span 
									style={{
										color: "#F57E47",
										fontSize: 10,
										fontWeight: "bold",
										marginBottom: 12,
										marginLeft: 16,
									}} >
									{"Business Tools"}
								</span>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 16,
										fontWeight: "bold",
										marginBottom: 14,
										marginLeft: 16,
										marginRight: 16,
										width: 208,
									}} >
									{"Canva – Free Business Plan Templates"}
								</span>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginLeft: 16,
										marginRight: 16,
										gap: 33,
									}}>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "flex-start",
											paddingRight: 2,
											gap: 4,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/eudyc0o6_expires_30_days.png"} 
											style={{
												width: 15,
												height: 15,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#6BD0F6",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Try Canva"}
										</span>
									</div>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "flex-start",
											paddingRight: 2,
											gap: 4,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/d7j0oyd0_expires_30_days.png"} 
											style={{
												width: 15,
												height: 15,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#979797",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Save for Later"}
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}